import Vue from 'vue'
import Vuex from 'vuex'
import AuthUser from '../store/modules/auth-user'

import CommonList from '../store/modules/common/list'
import Notification from '../store/modules/notification/notification'
import UserProfile from '../store/modules/UserProfile/list';
import TrekkingSingle from '../store/modules/trekking/single';
import SingleTrekRequest from '../store/modules/trekking/singleTrekking';
import Print from "./modules/print";

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        CommonList,
        AuthUser,
        Notification,
        UserProfile,
        TrekkingSingle,
        SingleTrekRequest,
        Print
    }
});

export default store